import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import question from './modules/question'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        question
    }
})
